export enum YoutubePlaylistContainerConstants {
  TOGGLE_YOUTUBE_PLAYLIST_MODAL_OPEN = '@YoutubePlaylistContainer/TOGGLE_YOUTUBE_PLAYLIST_MODAL_OPEN',

  GET_YOUTUBE_PLAYLIST = '@YoutubePlaylistContainer/GET_YOUTUBE_PLAYLIST',
  GET_YOUTUBE_PLAYLIST_REQUEST = '@YoutubePlaylistContainer/GET_YOUTUBE_PLAYLIST_REQUEST',
  GET_YOUTUBE_PLAYLIST_REQUEST_SUCCESS = '@YoutubePlaylistContainer/GET_YOUTUBE_PLAYLIST_REQUEST_SUCCESS',
  GET_YOUTUBE_PLAYLIST_REQUEST_ERROR = '@YoutubePlaylistContainer/GET_YOUTUBE_PLAYLIST_REQUEST_ERROR',

  GET_VIDEO_LENGTHS = '@YoutubePlaylistContainer/GET_VIDEO_LENGTHS',
  GET_VIDEO_LENGTHS_REQUEST = '@YoutubePlaylistContainer/GET_VIDEO_LENGTHS_REQUEST',
  GET_VIDEO_LENGTHS_REQUEST_SUCCESS = '@YoutubePlaylistContainer/GET_VIDEO_LENGTHS_REQUEST_SUCCESS',
  GET_VIDEO_LENGTHS_REQUEST_ERROR = '@YoutubePlaylistContainer/GET_VIDEO_LENGTHS_REQUEST_ERROR',
}
